import script from "./PosterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PosterModal.vue?vue&type=script&setup=true&lang=js"

import "./PosterModal.vue?vue&type=style&index=0&id=82bcc952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82bcc952"]])

export default __exports__